import React, { useState } from 'react';
import { BarChart2, Clock, MessageCircle, CheckCircle, Shield, Lock, Eye } from 'lucide-react';
import { SurveyQuestionnaire } from './SurveyQuestionnaire';
export function Surveys() {
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);
  const activeSurvey = {
    id: 1,
    title: 'Pulse bien-être Q4 2023',
    description: 'Partagez votre ressenti sur votre environnement de travail et votre équilibre vie professionnelle/vie personnelle.',
    closingDate: '18 nov. 2023',
    estimatedTime: '15 min',
    anonymous: true
  };
  const pastSurveys = [{
    id: 101,
    title: 'Pulse bien-être Q3 2023',
    participationDate: '15 août 2023',
    status: 'completed'
  }, {
    id: 102,
    title: 'Satisfaction outils de travail',
    participationDate: '10 juil. 2023',
    status: 'completed'
  }, {
    id: 103,
    title: 'Engagement employés 2023',
    participationDate: '5 mai 2023',
    status: 'completed'
  }];
  if (showQuestionnaire) {
    return <SurveyQuestionnaire survey={activeSurvey} onClose={() => setShowQuestionnaire(false)} data-id="element-1572" />;
  }
  return <div data-id="element-1573">
      <div className="mb-6" data-id="element-1574">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1575">Sondages</h1>
        <p className="text-gray-600" data-id="element-1576">
          Participez aux sondages et partagez votre opinion
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1577">
        <div className="lg:col-span-2" data-id="element-1578">
          <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1579">
            <div className="flex items-center justify-between mb-6" data-id="element-1580">
              <h2 className="text-lg font-semibold text-gray-900" data-id="element-1581">
                Sondage actif
              </h2>
              <BarChart2 className="h-5 w-5 text-blue-600" data-id="element-1582" />
            </div>
            {activeSurvey ? <div data-id="element-1583">
                <div className="bg-blue-50 rounded-lg p-5 mb-6" data-id="element-1584">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-1585">
                    {activeSurvey.title}
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-1586">
                    {activeSurvey.description}
                  </p>
                  <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-4" data-id="element-1587">
                    <div className="flex items-center" data-id="element-1588">
                      <Clock className="h-4 w-4 mr-1 text-blue-500" data-id="element-1589" />
                      <span data-id="element-1590">Fermeture: {activeSurvey.closingDate}</span>
                    </div>
                    <div className="flex items-center" data-id="element-1591">
                      <Clock className="h-4 w-4 mr-1 text-blue-500" data-id="element-1592" />
                      <span data-id="element-1593">Durée: {activeSurvey.estimatedTime}</span>
                    </div>
                    {activeSurvey.anonymous && <div className="flex items-center" data-id="element-1594">
                        <CheckCircle className="h-4 w-4 mr-1 text-green-500" data-id="element-1595" />
                        <span className="font-medium" data-id="element-1596">Anonyme</span>
                      </div>}
                  </div>
                  <button onClick={() => setShowQuestionnaire(true)} className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium transition-colors duration-150 ease-in-out" data-id="element-1597">
                    Répondre au sondage
                  </button>
                </div>

                <div className="border-t border-gray-200 pt-6 space-y-6" data-id="element-1598">
                  <div className="bg-green-50 border border-green-200 rounded-lg p-5" data-id="element-1599">
                    <div className="flex items-start gap-3 mb-3" data-id="element-1600">
                      <Shield className="h-6 w-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-1601" />
                      <div data-id="element-1602">
                        <h4 className="font-semibold text-green-900 mb-2" data-id="element-1603">
                          Vos réponses sont 100% anonymes
                        </h4>
                        <p className="text-sm text-green-800 leading-relaxed" data-id="element-1604">
                          Ce sondage est complètement anonyme. Aucune
                          information permettant de vous identifier n'est
                          collectée ou associée à vos réponses.
                        </p>
                      </div>
                    </div>

                    <div className="space-y-3 mt-4" data-id="element-1605">
                      <div className="flex items-start gap-2" data-id="element-1606">
                        <Lock className="h-4 w-4 text-green-600 flex-shrink-0 mt-0.5" data-id="element-1607" />
                        <p className="text-sm text-green-800" data-id="element-1608">
                          <span className="font-medium" data-id="element-1609">
                            Protection des données:
                          </span>{' '}
                          Vos réponses sont stockées de manière anonyme, sans
                          lien avec votre identité.
                        </p>
                      </div>
                      <div className="flex items-start gap-2" data-id="element-1610">
                        <Eye className="h-4 w-4 text-green-600 flex-shrink-0 mt-0.5" data-id="element-1611" />
                        <p className="text-sm text-green-800" data-id="element-1612">
                          <span className="font-medium" data-id="element-1613">
                            Confidentialité garantie:
                          </span>{' '}
                          Seules les données agrégées et statistiques sont
                          partagées avec la direction.
                        </p>
                      </div>
                      <div className="flex items-start gap-2" data-id="element-1614">
                        <CheckCircle className="h-4 w-4 text-green-600 flex-shrink-0 mt-0.5" data-id="element-1615" />
                        <p className="text-sm text-green-800" data-id="element-1616">
                          <span className="font-medium" data-id="element-1617">
                            Liberté d'expression:
                          </span>{' '}
                          Vous pouvez répondre en toute honnêteté sans crainte
                          d'être identifié.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div data-id="element-1618">
                    <h4 className="font-medium text-gray-900 mb-3" data-id="element-1619">
                      À quoi servent ces données ?
                    </h4>
                    <div className="text-sm text-gray-600 space-y-2" data-id="element-1620">
                      <p data-id="element-1621">
                        Les résultats de ce sondage permettent à la direction et
                        aux RH de :
                      </p>
                      <ul className="list-disc pl-5 space-y-1" data-id="element-1622">
                        <li data-id="element-1623">Mesurer le bien-être général des équipes</li>
                        <li data-id="element-1624">
                          Identifier les points d'amélioration dans
                          l'environnement de travail
                        </li>
                        <li data-id="element-1625">
                          Mettre en place des actions concrètes pour répondre à
                          vos besoins
                        </li>
                      </ul>
                      <p className="mt-3 font-medium text-gray-700" data-id="element-1626">
                        Important: Les données sont traitées de manière anonyme
                        et agrégée. Il est impossible d'identifier les
                        répondants individuels dans les résultats.
                      </p>
                    </div>
                  </div>
                </div>
              </div> : <div className="text-center py-8" data-id="element-1627">
                <div className="mx-auto h-12 w-12 rounded-full bg-gray-100 flex items-center justify-center mb-4" data-id="element-1628">
                  <BarChart2 className="h-6 w-6 text-gray-400" data-id="element-1629" />
                </div>
                <h3 className="text-gray-900 font-medium mb-1" data-id="element-1630">
                  Aucun sondage actif
                </h3>
                <p className="text-gray-500" data-id="element-1631">
                  Il n'y a pas de sondage en cours actuellement.
                </p>
              </div>}
          </div>
        </div>

        <div className="lg:col-span-1" data-id="element-1632">
          <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1633">
            <div className="flex items-center justify-between mb-6" data-id="element-1634">
              <h2 className="text-lg font-semibold text-gray-900" data-id="element-1635">
                Historique
              </h2>
              <MessageCircle className="h-5 w-5 text-blue-600" data-id="element-1636" />
            </div>
            {pastSurveys.length > 0 ? <div className="space-y-4" data-id="element-1637">
                {pastSurveys.map(survey => <div key={survey.id} className="border-l-4 border-green-500 pl-3 py-2" data-id="element-1638">
                    <div className="flex justify-between items-start" data-id="element-1639">
                      <div data-id="element-1640">
                        <p className="font-medium text-gray-900" data-id="element-1641">
                          {survey.title}
                        </p>
                        <p className="text-xs text-gray-600 mt-1" data-id="element-1642">
                          Complété le {survey.participationDate}
                        </p>
                      </div>
                      <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs" data-id="element-1643">
                        Complété
                      </span>
                    </div>
                  </div>)}
              </div> : <div className="text-center py-6" data-id="element-1644">
                <p className="text-gray-500" data-id="element-1645">
                  Aucun historique de participation
                </p>
              </div>}
            <div className="mt-6 text-center" data-id="element-1646">
              <button className="text-blue-600 text-sm font-medium hover:text-blue-800" data-id="element-1647">
                Voir tous les sondages passés
              </button>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 mt-6" data-id="element-1648">
            <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1649">
              Résultats partagés
            </h2>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-1650">
              <h3 className="font-medium text-gray-900 mb-2" data-id="element-1651">
                Pulse Q3 2023 - Résultats
              </h3>
              <p className="text-sm text-gray-600 mb-3" data-id="element-1652">
                Les résultats du sondage Q3 sont disponibles. Découvrez les
                actions qui seront mises en place suite à vos retours.
              </p>
              <button className="w-full py-2 px-4 border border-blue-600 text-blue-600 hover:bg-blue-50 rounded-md text-sm font-medium transition-colors duration-150 ease-in-out" data-id="element-1653">
                Consulter les résultats
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}